const TIME_RE = /^(\d{1,2}):(\d{2})(?::(\d{2}))?$/;

export const parseTimeOfDay = (value: string): Date | null => {
  const match = value.trim().match(TIME_RE);
  if (!match) return null;
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  const seconds = Number(match[3] ?? 0);
  if (hours > 23 || minutes > 59 || seconds > 59) return null;
  const next = new Date();
  next.setHours(hours, minutes, seconds, 0);
  return next;
};

export const formatTimeOfDay = (value: Date): string => {
  const hh = String(value.getHours()).padStart(2, '0');
  const mm = String(value.getMinutes()).padStart(2, '0');
  const ss = String(value.getSeconds()).padStart(2, '0');
  return `${hh}:${mm}:${ss}`;
};

export const isValidTimeOfDay = (value: string) =>
  parseTimeOfDay(value) !== null;

export const timeOfDayToSeconds = (value: string): number | null => {
  const parsed = parseTimeOfDay(value);
  if (!parsed) return null;
  return (
    parsed.getHours() * 3600 + parsed.getMinutes() * 60 + parsed.getSeconds()
  );
};
